import { render, staticRenderFns } from "./RealEstateFSSurvey.vue?vue&type=template&id=25637ec2"
import script from "./RealEstateFSSurvey.vue?vue&type=script&lang=ts"
export * from "./RealEstateFSSurvey.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports